import { Card, iconSizes, Stack, Text, Title } from '@common/ui'
import { IconExclamationCircle } from '@common/ui/icons'
import Center from '../../components/layout/Center'
import { com } from '@eidu/web'
import Action = com.eidu.entity.permission.Action
import actionLabel from '../../domain/permission/actionLabel'
import GlobalAction = com.eidu.entity.permission.GlobalAction
import EntityAction = com.eidu.entity.permission.EntityAction

const actionKey = (action: Action) => {
  if (action instanceof GlobalAction) return action.name
  else if (action instanceof EntityAction) return action.name
  else throw new Error(`Unsupported action: ${action}`)
}

export type PermissionErrorProps = {
  missingPermittedActions: Action[]
}

const PermissionError = ({ missingPermittedActions }: PermissionErrorProps) => (
  <Center style={{ minHeight: '100vh', backgroundColor: 'var(--trellis-color-surface-variant)' }}>
    <Card withBorder shadow="md" maw={400} ta="center" p="md">
      <Stack gap="xs" align="center">
        <IconExclamationCircle size={iconSizes.xl} stroke={1.5} color="var(--trellis-color-negative)" />
        <Title order={4}>Permission Error</Title>
        <Text mt="xs">You are missing the following permission to view this page:</Text>
        {missingPermittedActions.map((action) => (
          <Text key={actionKey(action)} fw={700} mt="xs">
            {actionLabel(action)}
          </Text>
        ))}
      </Stack>
    </Card>
  </Center>
)

export default PermissionError
